import OrderItemRepository from '@/repositories/OrderItemRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import OrderItemEntity from '@/entities/OrderItem'

export interface IFetchOrderItemsByPhotosUseCaseParams {
  orderItemRepository: OrderItemRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchOrderItemsByPhotosUseCase implements BaseUseCase {
  orderItemRepository: OrderItemRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ orderItemRepository, snapsnapGateway }: IFetchOrderItemsByPhotosUseCaseParams) {
    this.orderItemRepository = orderItemRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { photoIds?: number[]; eventId: number }) {
    try {
      const orderItems = await this.snapsnapGateway.OrderItem.getOrderItemsByPhotos(params)
      this.orderItemRepository.saveOrderItems({ orderItems })
      return orderItems.map(item => new OrderItemEntity(item))
    } catch (error) {
      throw error
    }
  }
}
